module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 17-9bb2a770146c29d3ccec261bd33b43de.webp";